/* tslint:disable */
/* eslint-disable */
export enum WorkItemCalculatedbyPropertyAmountEnum {
  All = 'All',
  Single = 'Single',
  Two = 'Two',
  ActiveOnly = 'ActiveOnly',
  ActiveMax = 'ActiveMax'
}
